import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "../node_modules/bootstrap/dist/js/bootstrap.min.js";
import Popper from 'popper.js';
import "react-toastify/dist/ReactToastify.css";
import App from './App';
import reportWebVitals from './reportWebVitals';
import './setupAxiosAuthInterceptor';
import './imageUploadGuard';
import Modal from 'react-modal';

// Needed so Esc / overlay click on confirm dialogs work reliably with react-modal.
Modal.setAppElement('#root');

// P1-E4: quiet console.log noise in production without touching the ~301
// individual call sites across this codebase. console.error/console.warn
// are untouched; `npm start` (NODE_ENV=development) keeps full logging.
if (process.env.NODE_ENV === 'production') {
  console.log = () => {};
}

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// A focused number input changes its value when the mouse wheel scrolls over it (price, quantity ...).
// Drop focus on wheel so scrolling the page never edits the number.
document.addEventListener(
  "wheel",
  (event) => {
    const el = event.target;
    if (el instanceof HTMLInputElement && el.type === "number" && document.activeElement === el) el.blur();
  },
  { passive: true }
);
